import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFavorite } from '../../utils/favorites';

/** Heart toggle for a restaurant or a dish; sends signed-out users to login. */
const FavoriteButton = ({ kind, id, className = 'favorite-btn', size = 18 }) => {
  const [isFavorite, toggle] = useFavorite(kind, id);
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const signedIn = await toggle();
    if (!signedIn) navigate('/login', { state: { from: location } });
  };

  const label = isFavorite ? 'Remove from favorites' : 'Save to favorites';
  return (
    <button type="button" className={className} onClick={onClick} aria-label={label} aria-pressed={isFavorite} title={label}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={isFavorite ? '#C5192D' : 'none'}
        stroke={isFavorite ? '#C5192D' : '#64748b'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
};

export default FavoriteButton;
